/**
 * Query for Items from the given tags. This method may return a subset of the requested tags
 *  as it only returns tags that are tracked as item (with type) in the system
 * @param newTags { any[] }
 * @param inventoryClient { any }
 * @param itemTypeQueryAttributes { string[] }
 * @return { Promise<Object.<string, ReducedItem> }
 */
export const queryItemsFromBasicTags = async (tagData, inventoryClient, itemTypeQueryAttributes, itemClassFilters) => {
  const newTags = [
    ...new Set(
      tagData.map((tag) => {
        return tag.Name;
      })
    )
  ];
  if (!newTags.length) {
    return Promise.resolve({});
  }

  /**
   * @type { InventoryVerificationData[] | null}
   */
  const results = await inventoryClient.getInventoryVerificationDataByVids(
    newTags,
    ["id", ...itemTypeQueryAttributes],
    itemClassFilters
  );

  if (!results) {
    return Promise.resolve({});
  }

  const firstSeenTimestamp = Date.now();
  const newItemByTag = results
    .map((raw) => {
      const { ofType = [] } = raw.associatedWithTrackingSession?.[0]?.tracksItem?.[0] || {};
      let type;
      if (ofType.length) {
        const { id, identifier, description, ...tenantProperties } = ofType[0];
        type = {
          id,
          identifier,
          description,
          ...tenantProperties
        };
      }

      return {
        vid: raw.vid,
        itemId: raw.associatedWithTrackingSession?.[0]?.tracksItem?.[0]?.id,
        type,
        firstSeenTimestamp
      };
    })
    .filter((item) => {
      return item.itemId && item.type;
    })
    .reduce((map, item) => {
      const clonedMap = { ...map };
      clonedMap[item.vid] = item;
      return clonedMap;
    }, {});

  return newItemByTag;
};
